import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import styled, { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { sprintf } from 'sprintf-js';

import Select from '../styleguide/form/SelectCustom';
import { changePerPage } from '../../actions/PageActions';
import { getPagePaginationSelector } from '../../selectors/page';

const StyledSelectWrapper = styled.div`
  max-width: 250px;
`;

const PerPage = ({ t, theme, pagination, dispatchChangePerPage }) => {
  const perPage = _.get(pagination, 'perPage');
  const onChange = value => {
    dispatchChangePerPage(value);
  };
  if (perPage) {
    const perPageN = _.toNumber(perPage);
    const options = [perPageN, perPageN * 2, perPageN * 5];
    const defaultValue = _.find(options, option => option === perPageN);
    return (
      <StyledSelectWrapper>
        <Select
          name="per-page"
          defaultValue={defaultValue ? defaultValue : null}
          options={_.map(options, perPage => {
            return { label: sprintf('%1$s %2$s', perPage, t('per page')), value: perPage };
          })}
          onChange={onChange}
        />
      </StyledSelectWrapper>
    );
  }
  return null;
};

const makeMapStateToProps = () => {
  const getPagePagination = getPagePaginationSelector();
  const mapStateToProps = (state, props) => {
    return { pagination: getPagePagination(state, props) };
  };
  return mapStateToProps;
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    dispatchChangePerPage: perPage => {
      const { history } = props;
      dispatch(changePerPage(perPage, history));
    }
  };
};

const PerPageConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(PerPage);

export default withTranslation()(withRouter(withTheme(PerPageConnected)));
